// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wsPi","content":"styles_content__qWoHi"};